import { apiAuth, apiResponseType } from "./index";

export const getGoals = (
  page = 1,
  params?: {
    unity_ids?: number[];
    goal_status_id?: string;
    start_date?: string;
    end_date?: string;
  }
): apiResponseType => {
  const queryParams = new URLSearchParams();
  queryParams.append("page", page.toString());

  if (params?.unity_ids && params.unity_ids.length > 0) {
    params.unity_ids.forEach((id) => {
      queryParams.append("unity_ids[]", id.toString());
    });
  }
  if (params?.goal_status_id) {
    queryParams.append("goal_status_id", params.goal_status_id);
  }
  if (params?.start_date) {
    queryParams.append("start_date", params.start_date);
  }
  if (params?.end_date) {
    queryParams.append("end_date", params.end_date);
  }

  return apiAuth.get(`goals?${queryParams.toString()}`);
};

export const createGoal = (data: {
  unity_id: number;
  start_date: string;
  end_date: string;
  working_days: number;
  target_value?: number;
  selected_working_days?: string[] | null;
}) => apiAuth.post("goals/store", data) as apiResponseType;

export const getGoalShow = (uuid: string) =>
  apiAuth.get(`goals/${uuid}/show`) as apiResponseType;

export const updateGoal = (
  uuid: string,
  data: {
    unity_id?: number;
    start_date?: string;
    end_date?: string;
    working_days?: number;
    target_value?: number;
    goal_status_id?: number;
    sellers?: Array<{
      id: number;
      target_value?: number | null;
      super_target_value?: number | null;
    }>;
  }
) => apiAuth.post(`goals/${uuid}/update`, data) as apiResponseType;

export const deleteGoal = (uuid: string) =>
  apiAuth.delete(`goals/${uuid}/destroy`) as apiResponseType;

export const toggleGoalStatus = (uuid: string) =>
  apiAuth.put(`goals/${uuid}/toggle-status`) as apiResponseType;

export const getGoalStatuses = () =>
  apiAuth.get("goals/statuses/select") as apiResponseType;

export const getGoalSellers = (uuid: string) =>
  apiAuth.get(`goals/${uuid}/sellers`) as apiResponseType;

export const applyAllGoalSellers = (
  uuid: string,
  data: {
    target_value?: number;
    super_target_value?: number;
  }
) => apiAuth.post(`goals/${uuid}/sellers/apply-all`, data) as apiResponseType;
